var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StaffList',_vm._b({},'StaffList',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }